import { getAuth } from "@clerk/remix/ssr.server";
import { LoaderFunctionArgs, redirect } from "@remix-run/node";
import Home from "~/routes/home";

export const loader = async (args: LoaderFunctionArgs) => {
  const ctx = await getAuth(args);
  if (ctx.userId) {
    return redirect("/memos");
  }

  return null;
};

export default function Index() {
  return <Home />;
}
